// Real data loader from schema_summary.csv
let tableSchema = [];

// CSV Parser function
const parseCSV = (csvText) => {
  const lines = csvText.trim().split('\n').filter(line => line.length > 0);
  const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));
  
  console.log('CSV Headers:', headers); // Debug
  
  return lines.slice(1).map((line, lineIndex) => {
    const values = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        values.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    values.push(current.trim()); // Add the last value
    
    const obj = {};
    headers.forEach((header, index) => {
      let value = (values[index] || '').replace(/"/g, '').trim();
      
      // Convert numeric strings to numbers
      if (header === 'count' || header === 'unique_vals' || header === 'na_count') {
        const numValue = parseInt(value);
        obj[header] = isNaN(numValue) ? 0 : numValue;
      } else {
        obj[header] = value;
      }
    });
    
    // Debug first few rows
    if (lineIndex < 3) {
      console.log(`Row ${lineIndex}:`, obj);
    }
    
    return obj;
  });
};

// Load schema data from API or CSV
export const loadSchemaData = async (useAPI = false) => {
  try {
    if (useAPI) {
      // Load from Python backend API using environment-configured URL
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      const response = await fetch(`${API_URL}/api/schema/all`);
      if (!response.ok) {
        throw new Error(`API request failed: ${response.statusText}`);
      }
      tableSchema = await response.json();
      console.log('Loaded schema data from API:', tableSchema.length, 'rows');
      return tableSchema;
    } else {
      // Load from CSV file (fallback)
      const response = await fetch('/schema_summary.csv');
      const csvText = await response.text();
      tableSchema = parseCSV(csvText);
      console.log('Loaded schema data from CSV:', tableSchema.length, 'rows');
      return tableSchema;
    }
  } catch (error) {
    console.error('Error loading schema data:', error);
    // If API fails, try CSV fallback
    if (useAPI) {
      console.log('API failed, falling back to CSV...');
      return loadSchemaData(false);
    }
    return [];
  }
};

// Get unique table names from the data (with schema if available)
export const getTableNames = (schema = tableSchema) => {
  const tables = [...new Set(schema.map(row => {
    // Just return the table name as-is
    // Backend already provides schema.table format where needed
    return row.table;
  }))];
  return tables.sort();
};

export const tableNames = [
  "bills_master",
  "actions", 
  "amendments",
  "committees",
  "congressmen",
  "cosponsors",
  "subjects", 
  "summaries",
  "text_versions",
  "related_bills"
];

export const getTableStats = (tableName, schema = tableSchema) => {
  // Filter by table name - backend already formatted it correctly
  const tableData = schema.filter(row => row.table === tableName);
  
  const totalRows = tableData.length > 0 ? tableData[0].count : 0;
  const totalColumns = tableData.length;
  const totalNullValues = tableData.reduce((sum, row) => sum + (row.na_count || 0), 0);
  const avgUniqueValues = tableData.length > 0 
    ? Math.round(tableData.reduce((sum, row) => sum + (row.unique_vals || 0), 0) / tableData.length)
    : 0;
    
  return {
    totalRows,
    totalColumns, 
    totalNullValues,
    avgUniqueValues,
    columns: tableData
  };
};

// No chart data needed - we display schema data directly in tables